// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 用户管理注册列表
import userList from '@/views/userList/index';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 小程序banner管理
import AppletBanner from '@/views/AdvertisingManagement/AppletBanner/index';
// 小程序首页管理
import miniIndex from '@/views/AdvertisingManagement/miniIndex/index';
// 麻将机桌面管理
import MahjongDesktop from '@/views/AdvertisingManagement/MahjongDesktop/index';
// 麻将机首页管理
import MahjongHomePage from '@/views/AdvertisingManagement/MahjongHomePage/index';
// 首页活动位
import indexActivity from '@/views/AdvertisingManagement/indexActivity/index';
// 分享素材
import SharingMaterials from '@/views/AdvertisingManagement/SharingMaterials/index';
// 收银系统pc端首页按钮设置
import cashierPc from '@/views/AdvertisingManagement/cashier/cashierPc';
// 收银系统小程序端首页按钮设置
import cashierMini from '@/views/AdvertisingManagement/cashier/cashierMini';
// demo
import demoJson from '@/views/demoView/demoJson';


// 404
import empty from '@/views/404/index';
// 机器管理
import MahjongManagement from '@/views/Mahjong/MahjongManagement';
// app升级
import appUpgrade from '@/views/Mahjong/appUpgrade';
// 场地管理
import GeneralDistributor from '@/views/SiteManagement/MerchantManagement/GeneralDistributor';
import business from '@/views/SiteManagement/MerchantManagement/business';
import Promoter from '@/views/SiteManagement/MerchantManagement/Promoter';
import orderList from '@/views/SiteManagement/TableFeeManagement/orderList';
import PaymenthCannel from '@/views/SiteManagement/TableFeeManagement/PaymenthCannel';
import CashWithdrawalList from '@/views/SiteManagement/CashWithdrawal/CashWithdrawalList';
import divideInto from '@/views/SiteManagement/divideInto/index';
import FirstLevelAgent from '@/views/SiteManagement/MerchantManagement/FirstLevelAgent';
// 门店
import storeOrder from '@/views/SiteManagement/storeManagement/storeOrder';
import storeList from '@/views/SiteManagement/storeManagement/storeList';
import gamebarOrder from '@/views/SiteManagement/gamebarManage/gamebarOrder';
import gamebarRecharge from '@/views/SiteManagement/gamebarManage/gamebarRecharge';
import gamebarUbiRecharge from '@/views/SiteManagement/gamebarManage/gamebarUbiRecharge';
import gameUbiManage from '@/views/SiteManagement/gamebarManage/gameUbiManage';



// 商城
import PointDistribution from '@/views/shoppingMall/integral/PointDistribution';
import IntegralConsumption from '@/views/shoppingMall/integral/IntegralConsumption';
import RedemptionOfPoints from '@/views/shoppingMall/activity/RedemptionOfPoints';
import taskManagemen from '@/views/shoppingMall/activity/taskManagemen';
import commodityList from '@/views/shoppingMall/commodity/commodityList';
import commodityOrder from '@/views/shoppingMall/commodity/commodityOrder';

// 客服电话配置
import customerService from '@/views/system/customerService';
// 设备入库单
import EquipmentWarehousing from '@/views/equipmentManagement/EquipmentWarehousing';
import salesSlip from '@/views/equipmentManagement/salesSlip';
import outboundOrder from '@/views/equipmentManagement/outboundOrder';


// 设备列表
import devicesList from '@/views/devicesManagement/devicesList';
// 平台概览
import PlatformOverview from '@/views/PlatformOverview/index';
// 数据查询
import queryData from '@/views/queryData/index';

// 销售端小程序首页按钮配置
import indexBtn from '@/views/AdvertisingManagement/SalesEndMini/indexBtn';


// 意见反馈
import Feedback from '@/views/customerService/Feedback';
// 单页管理
import SinglePage from '@/views/system/SinglePage';
import errorCode from '@/views/system/errorCode';
import industry from '@/views/system/industry';
import hallConfiguration from '@/views/system/hallConfiguration';
import popularCities from '@/views/system/popularCities';
import videoManagement from '@/views/system/videoManagement';
import leaflets from '@/views/system/leaflets';
import experience from '@/views/system/experience';
import grade from '@/views/system/grade';
import achieve from '@/views/system/achieve';
import DividendModification from '@/views/system/DividendModification';
import DeviceStyle from '@/views/system/DeviceStyle';
import CompetitionGame from '@/views/system/CompetitionGame';



//收银管理系统模块
import accountActivation from '@/views/cashierManagement/userManage/account';

// 活动管理
import SignInManagement from '@/views/ActivityCenter/SignInManagement';

// 社交管理
import SocialAccounts from '@/views/socialize/SocialAccounts';
import CreativeCenter from '@/views/socialize/CreativeCenter';
import HotspotManagement from '@/views/socialize/HotspotManagement';
import management from '@/views/socialize/management';
import CommentManagement from '@/views/socialize/CommentManagement';


//比赛
import competitionList from '@/views/competition/competitionList';



// 广告营销
import AdvertisementManagement from '@/views/AdvertisingMarketing/AdvertisementManagement';




import RegisteredUsers from '@/views/echartsView/RegisteredUsers';
import activeUsers from '@/views/echartsView/activeUsers';
import TableFeeIncome from '@/views/echartsView/TableFeeIncome';






// 系统环境变量

// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [ 
                    {path: '/goods/Goods',name: '商品管理', component: Goods,meta: { requireAuth: true}},
                    {path: '/404',name: '404',component: empty,meta: {requireAuth: true}}, 
                    {path: '/machine/Machine',name: '机器信息管理',component: Machine,meta: {requireAuth: true}}, 
                    {path: '/machine/MachineAisle',name: '货道信息管理',component: MachineAisle,meta: {requireAuth: true}}, 
                    {path: '/pay/Order',name: '交易订单',component: Order,meta: { requireAuth: true}},
                    {path: '/userList/index',name: '注册用户列表',component: userList,meta: {requireAuth: true}},
                    {path: '/system/user',name: '用户管理',component: user,meta: {requireAuth: true }}, 
                    {path: '/system/Module',name: '菜单管理',component: Module,meta: {requireAuth: true}}, 
                    {path: '/system/Role',name: '角色管理',component: Role, meta: {requireAuth: true}}, 
                    {path: '/MahjongDesktop/index',name: '麻将机桌面管理',component: MahjongDesktop,meta: {requireAuth: true}}, 
                    {path: '/MahjongHomePage/index',name: '麻将机首页管理',component: MahjongHomePage,meta: {requireAuth: true}}, 
                    {path: '/AppletBanner/index',name: '小程序banner管理',component: AppletBanner,meta: {requireAuth: true}}, 
                    // {path: '/system/Variable',name: '系统环境变量',component: Variable,meta: {requireAuth: true}},
                    {path: '/system/customerService',name: '平台客服电话配置',component: customerService,meta: {requireAuth: true}},
                    {path: '/system/SinglePage',name: '单页管理',component: SinglePage,meta: {requireAuth: true}},
                    {path: '/system/errorCode',name: '错误码管理',component: errorCode,meta: {requireAuth: true}},
                    {path: '/system/industry',name: '行业管理',component: industry,meta: {requireAuth: true}},
                    {path: '/system/Permission',name: '权限管理',component: Permission,meta: {requireAuth: true}},
                    {path: '/Mahjong/MahjongManagement',name: '机器管理',component: MahjongManagement,meta: {requireAuth: true}},
                    {path: '/Mahjong/appUpgrade',name: '权限管理',component: appUpgrade,meta: {requireAuth: true}},
                    {path: '/MerchantManagement/GeneralDistributor',name: '总经销商管理',component: GeneralDistributor,meta: {requireAuth: true}},
                    {path: '/MerchantManagement/business',name: '商家管理',component: business,meta: {requireAuth: true}},
                    {path: '/MerchantManagement/Promoter',name: '推广员管理',component: Promoter,meta: {requireAuth: true}},
                    {path: '/TableFeeManagement/orderList',name: '付费订单管理',component: orderList,meta: {requireAuth: true}},
                    {path: '/CashWithdrawal/CashWithdrawalList',name: '商家提现订单',component: CashWithdrawalList,meta: {requireAuth: true}},
                    {path: '/customerService/Feedback',name: '商家提现订单',component: Feedback,meta: {requireAuth: true}},
                    {path: '/divideInto/index',name: '分成规则',component: divideInto,meta: {requireAuth: true}},
                    {path: '/miniIndex/index',name: '展示图管理',component: miniIndex,meta: {requireAuth: true}},
                    {path: '/TableFeeManagement/PaymenthCannel',name: '支付通道管理',component: PaymenthCannel,meta: {requireAuth: true}},
                    {path: '/integral/PointDistribution',name: '积分收支记录',component: PointDistribution,meta: {requireAuth: true}},
                    {path: '/integral/IntegralConsumption',name: '积分消耗',component: IntegralConsumption,meta: {requireAuth: true}},
                    {path: '/activity/RedemptionOfPoints',name: '积分兑换设置',component: RedemptionOfPoints,meta: {requireAuth: true}},
                    {path: '/activity/taskManagemen',name: '任务管理',component: taskManagemen,meta: {requireAuth: true}},
                    {path: '/commodity/commodityList',name: '商品列表',component: commodityList,meta: {requireAuth: true}},
                    {path: '/commodity/commodityOrder',name: '商品订单列表',component: commodityOrder,meta: {requireAuth: true}},
                    {path: '/indexActivity/index',name: '活动位',component: indexActivity,meta: {requireAuth: true}},
                    {path: '/SharingMaterials/index',name: '分享素材',component: SharingMaterials,meta: {requireAuth: true}},
                    {path: '/EquipmentWarehousing',name: '入库单',component: EquipmentWarehousing,meta: {requireAuth: true}},
                    {path: '/devicesList',name: '设备列表',component: devicesList,meta: {requireAuth: true}},
                    {path: '/PlatformOverview/index',name: '平台概览',component: PlatformOverview,meta: {requireAuth: true}},
                    {path: '/SalesEndMini/indexBtn',name: '销售端首页按钮',component: indexBtn,meta: {requireAuth: true}},
                    {path: '/salesSlip',name: '销售单',component: salesSlip,meta: {requireAuth: true}},
                    {path: '/outboundOrder',name: '出库单',component: outboundOrder,meta: {requireAuth: true}},
                    {path: '/queryData/index',name: '数据查询',component: queryData,meta: {requireAuth: true}},
                    {path: '/cashier/cashierPc',name: '收银系统pc端菜单管理',component: cashierPc,meta: {requireAuth: true}},
                    {path: '/cashier/cashierMini',name: '收银系统小程序首页按钮',component: cashierMini,meta: {requireAuth: true}},
                    {path: '/userManage/accountActivation',name: '账号开通',component: accountActivation,meta: {requireAuth: true}},
                    {path: '/system/hallConfiguration',name: '大厅配置',component: hallConfiguration,meta: {requireAuth: true}},
                    {path: '/system/popularCities',name: '热门城市',component: popularCities,meta: {requireAuth: true}},
                    {path: '/system/leaflets',name: '宣传页管理',component: leaflets,meta: {requireAuth: true}},
                    {path: '/system/DividendModification',name: '桌费分润比例修改',component: DividendModification,meta: {requireAuth: true}},
                    {path: '/system/videoManagement',name: '视频管理',component: videoManagement,meta: {requireAuth: true}},
                    {path: '/ActivityCenter/SignInManagement',name: '签到管理',component: SignInManagement,meta: {requireAuth: true}},
                    {path: '/system/experience',name: '经验配置',component: experience,meta: {requireAuth: true}},
                    {path: '/system/grade',name: '等级管理',component: grade,meta: {requireAuth: true}},
                    {path: '/socialize/SocialAccounts',name: '社交账号管理',component: SocialAccounts,meta: {requireAuth: true}},
                    {path: '/socialize/CreativeCenter',name: '创作中心',component: CreativeCenter,meta: {requireAuth: true}},
                    {path: '/socialize/HotspotManagement',name: '热点管理',component: HotspotManagement,meta: {requireAuth: true}},
                    {path: '/socialize/management',name: '动态管理',component: management,meta: {requireAuth: true}},
                    {path: '/socialize/CommentManagement',name: '评论管理',component: CommentManagement,meta: {requireAuth: true}},
                    {path: '/AdvertisingMarketing/AdvertisementManagement',name: '广告管理',component: AdvertisementManagement,meta: {requireAuth: true}},
                    {path: '/RegisteredUsers',name: '注册用户',component: RegisteredUsers,meta: {requireAuth: true}},
                    {path: '/activeUsers',name: '活跃用户',component: activeUsers,meta: {requireAuth: true}},
                    {path: '/system/achieve',name: '成就管理',component: achieve,meta: {requireAuth: true}},
                    {path: '/TableFeeIncome',name: '桌费分润收益',component: TableFeeIncome,meta: {requireAuth: true}},
                    {path: '/MerchantManagement/FirstLevelAgent',name: '一级代理商',component: FirstLevelAgent,meta: {requireAuth: true}},
                    {path: '/system/DeviceStyle',name: '设备款式管理',component: DeviceStyle,meta: {requireAuth: true}},
                    {path: '/system/CompetitionGame',name: '比赛游戏',component: CompetitionGame,meta: {requireAuth: true}},
                    {path: '/demoJson',name: 'demo',component: demoJson,meta: {requireAuth: true}},
                    {path: '/competition/competitionList',name: '比赛列表',component: competitionList,meta: {requireAuth: true}},
                    {path: '/storeManagement/storeOrder',name: '门店订单',component: storeOrder,meta: {requireAuth: true}},
                    {path: '/storeManagement/storeList',name: '门店列表',component: storeList,meta: {requireAuth: true}},
                    {path: '/gamebarManage/gamebarOrder',name: 'gamebar订单',component: gamebarOrder,meta: {requireAuth: true}},
                    {path: '/gamebarManage/gamebarRecharge',name: 'gamebar充值管理',component: gamebarRecharge,meta: {requireAuth: true}},
                    {path: '/gamebarManage/gamebarUbiRecharge',name: 'gamebarU币充值',component: gamebarUbiRecharge,meta: {requireAuth: true}},
                    {path: '/gamebarManage/gameUbiManage',name: 'game玩法配置',component: gameUbiManage,meta: {requireAuth: true}},
                    
                ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js